import React from "react";
import Switch from "@mui/material/Switch";
import { SxProps, useTheme } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";

interface CustomToggleSwitchProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  activeColor?: string;
  inactiveColor?: string;
  disabled?: boolean;
  sx?: SxProps;
}

const CustomToggleSwitch: React.FC<CustomToggleSwitchProps> = ({
  checked,
  onChange,
  activeColor,
  inactiveColor = "#ccc",
  disabled = false,
  sx,
}) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      label=""
      control={
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          inputProps={{ "aria-label": "controlled" }}
          sx={{
            ...sx,
            width: 44,
            height: 20,
            padding: 0,
            "& .MuiSwitch-switchBase": {
              padding: 0.2,
              pt: 0.4,
              transform: "translateX(2px)",
              "&.Mui-checked": {
                transform: "translateX(24px)",
                paddingTop: 0.4,
                color: theme.palette.customColors.white,
                "& + .MuiSwitch-track": {
                  backgroundColor:
                    activeColor || theme.palette.customColors.purple,
                  opacity: 1,
                },
              },
            },
            "& .MuiSwitch-thumb": {
              width: 14,
              height: 14,
              boxShadow: "none",
            },
            "& .MuiSwitch-track": {
              borderRadius: 20,
              backgroundColor: inactiveColor,
              opacity: 1,
            },
          }}
        />
      }
    />
  );
};

export default CustomToggleSwitch;
